import * as _ from 'lodash';
import { primaryOutcomeMetrics } from '../../../ng2/shared/constants/primary-outcome-metrics.constant';
import { IRegentsExam, RegentsSubject } from '../../../ng2/shared/constants/regents.constant';

function filterSupports(supports: ISupportCategories): { [key: string]: ISupportCategory } {
  const filteredSupports = {};
  _.forEach(supports, (value: ISupportCategory, key) => {
    if (!value.isDeprecated) {
      filteredSupports[key] = value;
    } else {
      return;
    }
  });
  return filteredSupports;
}

export interface ISupportCategory {
  key: string;
  humanName: string;
  humanShort: string;
  isDeprecated: boolean;
  metaData?: string;
  primaryOutcomeMetrics: string[];
  subOptions?: Array<{ value: string; humanName: string; hasActiveSupports?: boolean }>;
  subOptionLabel?: string;
  hasActiveSupports?: boolean;
}

export interface ISupportCategories {
  REGENTS_PREP: ISupportCategory;
  ATTENDANCE: ISupportCategory;
  ACADEMIC: ISupportCategory;
  PHYS_HEALTH_SERVICES: ISupportCategory;
  EXTRACURRICULAR: ISupportCategory;
  MENTAL_HEALTH_SERVICES: ISupportCategory;
  COLLEGE_CAREER: ISupportCategory;
  OTHER: ISupportCategory;
}

export const SupportCategories: ISupportCategories = {
  REGENTS_PREP: {
    key: 'REGENTS_PREP',
    humanName: 'Regents Prep',
    humanShort: 'Regents',
    metaData: 'examSubject',
    isDeprecated: false,
    primaryOutcomeMetrics: primaryOutcomeMetrics.PRIMARY_OUTCOME_METRICS_REGENTS,
    subOptionLabel: 'Select a Regents exam*',
    subOptions: (_.map(RegentsSubject, (subj: IRegentsExam) => {
      return {
        value: subj.key,
        humanName: subj.humanName,
      };
    }) as unknown) as Array<{ value: string; humanName: string; hasActiveSupports?: boolean }>,
  },
  ATTENDANCE: {
    key: 'ATTENDANCE',
    humanName: 'Attendance',
    humanShort: 'Attendance',
    metaData: 'serviceName',
    isDeprecated: false,
    subOptionLabel: 'Select an intervention*',
    subOptions: [
      {
        value: null,
        humanName: '-',
      },
      {
        value: 'Success Mentoring',
        humanName: 'Success Mentoring',
      },
    ],
    primaryOutcomeMetrics: primaryOutcomeMetrics.PRIMARY_OUTCOME_METRCIS_ATT,
  },
  ACADEMIC: {
    key: 'ACADEMIC',
    humanName: 'Academic',
    humanShort: 'Acad',
    metaData: 'serviceName',
    isDeprecated: false,
    primaryOutcomeMetrics: [],
    subOptionLabel: 'Select an intervention*',
    subOptions: [
      {
        value: 'Imagine Math (Renewal)',
        humanName: 'Imagine Math (Renewal)',
      },
      {
        value: 'Rewards(Renewal)',
        humanName: 'Rewards(Renewal)',
      },
      {
        value: 'Wilson Reading (NVCMO)',
        humanName: 'Wilson Reading (NVCMO)',
      },
      {
        value: 'Read 180 (NVCMO)',
        humanName: 'Read 180 (NVCMO)',
      },
      {
        value: 'Other',
        humanName: 'Other',
      },
    ],
  },
  PHYS_HEALTH_SERVICES: {
    key: 'PHYS_HEALTH_SERVICES',
    humanName: 'Physical Health Services',
    humanShort: 'Phys Health',
    metaData: 'serviceName',
    isDeprecated: false,
    primaryOutcomeMetrics: primaryOutcomeMetrics.PRIMARY_OUTCOME_METRCIS_ATT,
    subOptionLabel: 'Select a service*',
    subOptions: [
      {
        value: 'Vision',
        humanName: 'Vision',
      },
      { value: 'Dental', humanName: 'Dental' },
      { value: 'Asthma', humanName: 'Asthma' },
      { value: 'Other', humanName: 'Other' },
    ],
  },
  MENTAL_HEALTH_SERVICES: {
    key: 'MENTAL_HEALTH_SERVICES',
    humanName: 'Mental Health Services',
    humanShort: 'Mental Health',
    isDeprecated: false,
    primaryOutcomeMetrics: primaryOutcomeMetrics.PRIMARY_OUTCOME_METRCIS_ATT,
  },
  EXTRACURRICULAR: {
    key: 'EXTRACURRICULAR',
    humanName: 'Extracurricular Activities',
    humanShort: 'Extracurricular',
    isDeprecated: false,
    primaryOutcomeMetrics: [],
  },
  COLLEGE_CAREER: {
    key: 'COLLEGE_CAREER',
    isDeprecated: true,
    humanName: 'College and Career Activities',
    humanShort: 'Postsec',
    primaryOutcomeMetrics: [],
  },
  OTHER: {
    key: 'OTHER',
    isDeprecated: false,
    humanName: 'Other',
    humanShort: 'Other',
    primaryOutcomeMetrics: [],
  },
};

// Filter out supports that are not deprecated. (Jack)
export const ActiveSupportCategories = filterSupports(SupportCategories);
